import {CONST_MASSES} from './const_masses.js';
import {CONST_TARIFS} from './const_tarifs.js';
import {CONST_COLORS} from './const_colors.js';

const colors = CONST_COLORS.map((c)=>{
	const value_text = c.text.split(' - ');
	return {
		ral: value_text[0],
		color_text: value_text[1],
		clear: c.clear,
		rgb: c.value,
		atg: !!c.atg
	}
});
const refs_without_mass = [];
const refs = CONST_TARIFS.filter(
	(t)=>(t['Code article'].length>1&&t['Libellé'].length>1)
).map((t)=>{
	let ref = t["Code article"];
	let prix = t["PV HT"].replace(/[^0-9\-\.\,]/g,'').replace(',','.');
	if(!prix.length){
		prix = '0';
	}
	let mass = CONST_MASSES[ref];
	if(typeof mass === 'undefined'){
		refs_without_mass.push(ref);
	}
	return {
		masse: mass||0,
    	prix_ht: parseFloat(prix),
    	ref_CECA: ref,
    	description: t["Libellé"]
	}
});

if(refs_without_mass.length){
	console.error('refs_without_mass',refs_without_mass);
}

export {colors,refs};
